import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from './spinner.module.scss';

/**
 * sizes:
 *  - tiny: 16px
 *  - small: 24px
 *  - medium: 32px
 *  - big: 48px
 */

function Spinner({ size, color, className }) {
  const borderColor = color && `${color} transparent transparent transparent`;
  return (
    <div className={classNames(classes.container, className)}>
      <div className={classNames(classes.spinner, classes[size])}>
        <div style={{ borderColor: borderColor }}></div>
        <div style={{ borderColor: borderColor }}></div>
        <div style={{ borderColor: borderColor }}></div>
        <div style={{ borderColor: borderColor }}></div>
      </div>
    </div>
  );
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'big']).isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Spinner.defaultProps = {
  size: 'small',
  color: 'black',
};

export default Spinner;
